document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.cpb-wrapper');
  if (!wrapper) return;

  const pendantRequired = 2;

  let selectedChain = null;
  let selectedPendants = {};

  const chainPanel = document.querySelector('[data-panel="chain"]');
  const pendantPanel = document.querySelector('[data-panel="pendant"]');
  const checkoutBtn = document.getElementById('cpb-checkout-btn');
  const selectedContainer = document.getElementById('cpb-selected-items');
  const chainCount = document.getElementById('cpb-chain-count');
  const pendantCount = document.getElementById('cpb-pendant-count');

  function getVariantId(card) {
    const input = card.querySelector('.cpb-variant-select');
    return input ? input.value : null;
  }

  function getProductData(card) {
  return {
    type: card.dataset.productType,
    title: card.dataset.productTitle,
    image: card.dataset.productImage,
    variantId: getVariantId(card),
    price: parseFloat(card.dataset.productPrice)
  };
}

  function getPendingQty(card) {
    const qtyValue = card.querySelector('.cpb-qty-value');
    return qtyValue ? Number(qtyValue.textContent) : 0;
  }

  function setPendingQty(card, qty) {
    const qtyValue = card.querySelector('.cpb-qty-value');
    if (qtyValue) qtyValue.textContent = qty;
  }

  function getPendantTotalQty() {
    return Object.values(selectedPendants).reduce((sum, item) => sum + item.qty, 0);
  }

  function updateProgress() {
    document.querySelectorAll('.cpb-step').forEach(step => {
      step.classList.remove('active', 'completed');
    });

    const totalPendantQty = getPendantTotalQty();

    if (!selectedChain) {
      document.querySelector('[data-step="1"]').classList.add('active');
    } else if (totalPendantQty < pendantRequired) {
      document.querySelector('[data-step="1"]').classList.add('completed');
      document.querySelector('[data-step="2"]').classList.add('active');
    } else {
      document.querySelector('[data-step="1"]').classList.add('completed');
      document.querySelector('[data-step="2"]').classList.add('completed');
      document.querySelector('[data-step="3"]').classList.add('active');
    }
  }

  function updatePanels() {
    if (selectedChain) {
      chainPanel.classList.remove('active');
      pendantPanel.classList.add('active');
    } else {
      chainPanel.classList.add('active');
      pendantPanel.classList.remove('active');
    }
  }

  function selectedItemHTML(item, type, key = '') {
    const qtyText = type === 'pendant' ? `Qty: ${item.qty}` : 'Qty: 1';

    return `
      <div class="cpb-selected-item">
        <img src="${item.image}" alt="${item.title}">
        <div class="cpb-selected-info">
          <h4>${item.title}</h4>
          <p>${type === 'chain' ? 'Chain' : 'Pendant'} - ${qtyText}</p>
        </div>
        <button class="cpb-remove" data-remove-type="${type}" data-remove-key="${key}">×</button>
      </div>
    `;
  }

  function resetPendantPendingQty() {
    document.querySelectorAll('.cpb-card[data-product-type="pendant"]').forEach(card => {
      setPendingQty(card, 1);
    });
  }

  function updateCardStates() {
  const totalPendantQty = getPendantTotalQty();

  document.querySelectorAll('.cpb-card').forEach(card => {
    const variantId = getVariantId(card);
    const type = card.dataset.productType;

    card.classList.remove('selected', 'all-pendant-selected');

    if (selectedChain && selectedChain.variantId === variantId) {
      card.classList.add('selected');
    }

    if (selectedPendants[variantId]) {
      card.classList.add('selected');
    }

    /* When 2 pendants selected, blur all pendant products */
    if (type === 'pendant' && totalPendantQty >= pendantRequired) {
      card.classList.add('all-pendant-selected');
    }
  });
}

 function updateSummary() {
  const totalPendantQty = getPendantTotalQty();

  chainCount.textContent = selectedChain ? 1 : 0;
  pendantCount.textContent = totalPendantQty;

  selectedContainer.innerHTML = '';

  if (!selectedChain && totalPendantQty === 0) {
    selectedContainer.innerHTML = '<p class="cpb-empty">No products selected yet.</p>';
  }

  if (selectedChain) {
    selectedContainer.innerHTML += selectedItemHTML(selectedChain, 'chain');
  }

  Object.keys(selectedPendants).forEach(key => {
    selectedContainer.innerHTML += selectedItemHTML(selectedPendants[key], 'pendant', key);
  });

  const isComplete = selectedChain && totalPendantQty === pendantRequired;

  const bundleTotal = document.getElementById('cpb-bundle-total');

  if (bundleTotal) {
    if (isComplete) {
      let originalPrice = 0;

      if (selectedChain && !isNaN(selectedChain.price)) {
        originalPrice += selectedChain.price;
      }

      Object.values(selectedPendants).forEach(item => {
        if (!isNaN(item.price)) {
          originalPrice += item.price * item.qty;
        }
      });

      bundleTotal.style.display = 'block';
      bundleTotal.innerHTML = `
        <div class="cpb-price-wrapper">
          <span class="cpb-total-label">Total:</span>
          <span class="cpb-original-price">₹${Math.round(originalPrice)}</span>
          <span class="cpb-offer-price">₹849</span>
        </div>
      `;
    } else {
      bundleTotal.style.display = 'none';
      bundleTotal.innerHTML = '';
    }
  }

  checkoutBtn.disabled = !isComplete;
  checkoutBtn.textContent = isComplete
    ? 'Add Bundle & Checkout'
    : 'Select 1 Chain & 2 Pendants';

  updateProgress();
  updatePanels();
  updateCardStates();
}
  document.querySelectorAll('.cpb-add-btn').forEach(button => {
    button.addEventListener('click', function () {
      const card = this.closest('.cpb-card');
      const data = getProductData(card);

      if (!data.variantId) return;

      if (data.type === 'chain') {
        selectedChain = data;
        selectedPendants = {};
        resetPendantPendingQty();
        updateSummary();
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('cpb-qty-plus')) {
      const card = event.target.closest('.cpb-card');

      if (!selectedChain) {
        alert('Please select a chain first.');
        return;
      }

      let currentQty = getPendingQty(card);

      if (currentQty >= pendantRequired) {
        alert('Maximum 2 quantity allowed for one pendant.');
        return;
      }

      setPendingQty(card, currentQty + 1);
    }

    if (event.target.classList.contains('cpb-qty-minus')) {
      const card = event.target.closest('.cpb-card');
      let currentQty = getPendingQty(card);

      if (currentQty <= 0) return;

      setPendingQty(card, currentQty - 1);
    }

    if (event.target.classList.contains('cpb-pendant-add-btn')) {
      const card = event.target.closest('.cpb-card');
      const data = getProductData(card);
      const qty = getPendingQty(card);

      if (!selectedChain) {
        alert('Please select a chain first.');
        return;
      }

      if (qty <= 0) {
        alert('Please select quantity first.');
        return;
      }

      if (qty > pendantRequired) {
        alert('Maximum 2 quantity allowed.');
        return;
      }

      const currentTotal = getPendantTotalQty();
      const oldQty = selectedPendants[data.variantId] ? selectedPendants[data.variantId].qty : 0;
      const newTotal = currentTotal - oldQty + qty;

      if (newTotal > pendantRequired) {
        alert('Total pendant quantity cannot be more than 2.');
        return;
      }

      selectedPendants[data.variantId] = {
        ...data,
        qty: qty
      };

      updateSummary();
    }
  });

  selectedContainer.addEventListener('click', function (event) {
    if (!event.target.classList.contains('cpb-remove')) return;

    const type = event.target.dataset.removeType;
    const key = event.target.dataset.removeKey;

    if (type === 'chain') {
      selectedChain = null;
      selectedPendants = {};
      resetPendantPendingQty();
    }

    if (type === 'pendant') {
      delete selectedPendants[key];

      document.querySelectorAll('.cpb-card[data-product-type="pendant"]').forEach(card => {
        if (getVariantId(card) === key) {
          setPendingQty(card, 0);
        }
      });
    }

    updateSummary();
  });

  checkoutBtn.addEventListener('click', async function () {
    const totalPendantQty = getPendantTotalQty();

    if (!selectedChain || totalPendantQty !== pendantRequired) {
      alert('Please select 1 chain and 2 pendants.');
      return;
    }

    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Adding...';

    const items = [
      {
        id: Number(selectedChain.variantId),
        quantity: 1,
        properties: {
          '_bundle': 'Chain + Pendant Bundle',
          '_bundle_type': 'Chain'
        }
      },
      ...Object.values(selectedPendants).map(item => ({
        id: Number(item.variantId),
        quantity: item.qty,
        properties: {
          '_bundle': 'Chain + Pendant Bundle',
          '_bundle_type': 'Pendant'
        }
      }))
    ];

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Cart add failed');
      }

      setTimeout(function () {
        if (typeof handleShiprocketSmartCartBuy === 'function') {
          handleShiprocketSmartCartBuy();
        } else {
          const shiprocketBtn = document.querySelector('#sr-buy-now-button');
          if (shiprocketBtn) {
            shiprocketBtn.click();
          } else {
            window.location.href = '/checkout';
          }
        }
      }, 800);

    } catch (error) {
      console.error(error);
      alert('Something went wrong. Please try again.');
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = 'Add Bundle & Checkout';
    }
  });

  updateSummary();
});